import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Button } from "reactstrap";
import CustomForm from "../../../custom/Forms/CustomForm";
import SelectInput from "../../../custom/components/Select-Input/SelectInput";
import TextInput from "../../../custom/components/Text-Input/TextInput";
import { Link, useNavigate, useParams } from "react-router-dom";
import { createPageData, createFormData } from "./CommissioningFile";
import CheckboxInput from "../../../custom/components/CheckBox-Input/CheckboxInput";
import Asterisks from "../../../custom/components/Asterisks/Asterisks";
import { validate } from "../../../custom/validations/Validate";
import {
  dropdownData,
  getRecords,
  saveRecords,
} from "../../../services/api.service";
import { toast } from "react-toastify";
import { isAlphabet } from "../../../custom/validations/Ruls";
import PopupManager from "../../../services/popup/PopupManager.js";

const CommissioningCreate = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  } = createPageData();

  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(createFormData());
  const [customerSelect, setCustomerSelect] = useState("");
  const [customerSelectOptions, setCustomerSelectOptions] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [fetchedData, setFetchedData] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const [itemIndexToRemove, setItemIndexToRemove] = useState(0); // Track the index of the item to remove

  useEffect(() => {
    const loginUserId = JSON.parse(localStorage.getItem("userDetails"))?.id;
    if (id) {
      getEditData(id, loginUserId);
    } else {
      getUserMasterDropData();
    }
  }, [id]);

  useEffect(() => {
    if (fetchedData) {
      let data = fetchedData;
      setFormData((prevState) => ({
        ...prevState,
        inputData: {
          ...prevState.inputData,
          ...data,
        },
      }));
    }
  }, [fetchedData]);

  const getEditData = async (id, loginUserId) => {
    try {
      let payload = {
        modelName: initialPayload?.modelName,
      };
      if (id) {
        payload.whereCondition = { id: id };
      }
      const responseData = await getRecords(payload, getEndpoint);

      if (responseData?.data && responseData.data.length > 0) {
        const data = responseData.data[0];
        getUserMasterDropData(data?.customer_id);
        setFetchedData(data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };

  const getUserMasterDropData = async (customerId) => {
    try {
      let payload = {
        modelName: "user_masters",
        whereCondition: {
          user_type: 3,
          is_active: true,
        },
      };

      const responseData = await getRecords(payload, "/listCustomers");
      if (responseData.data && responseData.data.length > 0) {
        const dropdownResponseData = await dropdownData(
          responseData.data,
          "first_name"
        );
        if (id) {
          dropdownResponseData[0].options.forEach((element) => {
            if (element.value == customerId) {
              setCustomerSelect(element);
            }
          });
        }
        setCustomerSelectOptions(dropdownResponseData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  const onInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    const fieldError = validate(validationType, {
      [name]: value,
    });
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [name]: fieldError[name] || null,
    }));
    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        [name]: type === "checkbox" ? (checked === true ? 1 : 0) : value,
      },
    }));
  };

  const handleCustomerSelect = (options) => {
    const selectedValue = options ? options.value : "";
    const fieldError = validate(validationType, {
      customer_id: selectedValue,
    });

    setCustomerSelect(options);
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      customer_id: fieldError?.customer_id || "",
    }));

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        customer_id: selectedValue,
      },
    }));
  };

  const handleAddListDetails = () => {
    const errors = {};
    formData?.inputData &&
      formData?.inputData?.list_details &&
      formData?.inputData?.list_details?.forEach((person, index) => {
        ["name"].forEach((field) => {
          if (!person[field]?.trim()) {
            errors.list_details = {
              ...errors.list_details,
              [index]: {
                ...errors.list_details?.[index],
                [field]: `${field
                  .replace(/_/g, " ")
                  ?.replace(/\b\w/g, (char) =>
                    char?.toUpperCase()
                  )} is required`,
              },
            };
          }
          if (field === "name" && person[field]) {
            const alphabetError = isAlphabet(person[field], "name");
            if (alphabetError) {
              errors.list_details = {
                ...errors.list_details,
                [index]: {
                  ...errors.list_details?.[index],
                  name: alphabetError,
                },
              };
            }
          }
        });
      });

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      //  toast.error(
      //    "Please fix errors in the existing list details before adding a new one."
      //  );
      return;
    }

    setFormData((prev) => ({
      ...prev,
      inputData: {
        ...prev.inputData,
        list_details: [...prev.inputData.list_details, { name: "" }],
      },
    }));
  };

  const handleListDetailsOnChange = (e, index) => {
    const { name, value } = e.target;

    let errorMessage = "";
    if (name === "name" && value.trim()) {
      const alphabetError = isAlphabet(value, name);
      if (alphabetError) {
        errorMessage = alphabetError;
      }
    }
    setFormErrors((prev) => ({
      ...prev,
      list_details: {
        ...prev.list_details,
        [index]: {
          ...prev.list_details?.[index],
          [name]: value.trim()
            ? errorMessage || ""
            : `${name.replace(/\b\w/g, (char) =>
                char.toUpperCase()
              )} is required`,
        },
      },
    }));

    setFormData((prev) => {
      const updatedDetails = [...prev.inputData?.list_details];
      updatedDetails[index][name] = value;
      return {
        ...prev,
        inputData: {
          ...prev.inputData,
          list_details: updatedDetails,
        },
      };
    });
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoadingData(true);

      const validationErrors = validate(validationType, formData.inputData);
      let combinedErrors = { ...validationErrors };

      const listDetailsErrors = {};
      formData?.inputData?.list_details?.forEach((person, index) => {
        ["name"].forEach((field) => {
          if (!person[field]?.trim()) {
            if (!listDetailsErrors.list_details)
              listDetailsErrors.list_details = {};

            listDetailsErrors.list_details[index] = {
              ...listDetailsErrors.list_details[index],
              [field]: `${field
                .replace(/_/g, " ")
                ?.replace(/\b\w/g, (char) => char?.toUpperCase())} is required`,
            };
          }
          if (field === "name" && person[field]) {
            const alphabetError = isAlphabet(person[field], "name");
            if (alphabetError) {
              listDetailsErrors.list_details = {
                ...listDetailsErrors.list_details,
                [index]: {
                  ...listDetailsErrors.list_details?.[index],
                  name: alphabetError,
                },
              };
            }
          }
        });
      });

      if (Object.keys(listDetailsErrors.list_details || {}).length > 0) {
        combinedErrors = {
          ...combinedErrors,
          list_details: {
            ...combinedErrors.list_details,
            ...listDetailsErrors.list_details,
          },
        };
      }

      if (Object.keys(combinedErrors).length > 0) {
        setLoadingData(false);

        setFormErrors(combinedErrors);

        return;
      }

      const local_project_id = JSON.parse(localStorage.getItem("projectID"));
      const payload = {
        id: id,
        modelName: initialPayload?.modelName,
        inputData: {
          ...formData?.inputData,
          project_id: local_project_id,
        },
      };

      const responseData = await saveRecords(payload, "/saveRecords");

      if (responseData && responseData.code == 1) {
        toast.success(
          `${headerName} ${id ? "updated" : "saved"} successfully!`
        );
        navigate(navigatePage?.back);
      } else {
        toast.error(
          responseData?.message ||
            `Error while ${id ? "updating" : "saving"} ${headerName}!`
        );
      }
    } catch (error) {
      console.log("err", error);
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      setLoadingData(false);
    }
  };

  // handle remove item
  const handleRemoveListDetails = (index) => {
    if (id) {
      setPopupMessage("Are you sure you want to remove this?");
      setShowConfirmation(true);
      setItemIndexToRemove(index);
    } else {
      removeItem(index);
    }
  };

  const removeItem = async (index) => {
    const updatedErrors = { ...formErrors };
    delete updatedErrors.list_details?.[index];

    setFormData((prev) => {
      const updatedDetails = prev.inputData.list_details.filter(
        (_, i) => i !== index
      );

      return {
        ...prev,
        inputData: {
          ...prev.inputData,
          list_details: updatedDetails,
        },
      };
    });
  };

  const handleConfirm = async () => {
    setShowConfirmation(false);
    removeItem(itemIndexToRemove);
    // Simulate an API call or logic to handle removal
    const success = true; // Change this to simulate error scenario

    if (success) {
      setPopupMessage("Item removed successfully!");
      setIsError(false);
    } else {
      setPopupMessage("Failed to remove this. Please try again.");
      setIsError(true);
    }

    setShowPopup(true);
  };

  const handleRedirectToLogin = () => {
    setShowPopup(false);
  };

  return (
    <CustomForm
      title={id ? "UPDATE " + headerName : "CREATE " + headerName}
      loadingData={loadingData}
      onFormSubmit={handleSubmit}
      handleBackClick={() => navigate(navigatePage?.back)}
      id={id}>
      <PopupManager
        showPopup={showPopup}
        setShowPopup={setShowPopup}
        showConfirmation={showConfirmation}
        setShowConfirmation={setShowConfirmation}
        popupMessage={popupMessage}
        isError={isError}
        onConfirm={handleConfirm}
        onRedirectToLogin={handleRedirectToLogin}
      />
      <Row className="mt-2">
        
        <Col md="6" className="mt-3">
          <SelectInput
            label="Customer"
            value={customerSelect}
            options={customerSelectOptions}
            onSelect={(selected) => handleCustomerSelect(selected)}
            placeholder="Select customer"
            labelClassName="form-label"
            isClearable={false}
            asterisk={true}
            customError={formErrors?.customer_id}
          />
        </Col>

        <Col md="6" className="mt-3">
          <TextInput
            label="Form Name"
            name="form_name"
            value={formData?.inputData?.form_name}
            onChange={onInputChange}
            placeholder="Form Name"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.form_name}
          />
        </Col>
        <Col md="6" className="mt-3">
          <TextInput
            label="Reference Document No"
            name="ref_document_no"
            value={formData?.inputData?.ref_document_no}
            onChange={onInputChange}
            placeholder="Reference document no"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.ref_document_no}
          />
        </Col>
      </Row>

      <Row className="mt-4">
        <Col
          style={{
            marginLeft: "",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingBlock: "5px",
            gap: "1rem",
          }}>
          <div>
            <h6 className="h-6-heading m-0">Form Details</h6>
          </div>
          <Button
            color="primary"
            className="waves-effect waves-light me-1"
            onClick={handleAddListDetails}
            style={{ background: "#006eb9" }}>
            Add
          </Button>
        </Col>
        <div className="table">
          <table className="table table-hover">
            <thead style={{ backgroundColor: "#8AC1E8" }}>
              <tr
                style={{
                  borderBottom: "1px solid black",
                }}>
                <th style={{ width: "10%", textAlign: "left" }}>Sr. No</th>
                <th style={{ width: "70%", textAlign: "left" }}>
                  Name <Asterisks asterisk={true} />
                </th>
                <th
                  style={{
                    width: "20%",
                    textAlign: "left",
                    paddingLeft: "5rem",
                  }}>
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {formData?.inputData?.list_details?.map((item, index) => (
                <tr
                  key={index + 1}
                  style={{
                    borderBottom: "1px solid #cccccc",
                    verticalAlign: "middle",
                  }}>
                  <td style={{ width: "10%", textAlign: "left" }}>
                    {index + 1}
                  </td>
                  <td style={{ width: "70%" }}>
                    <TextInput
                      name="name"
                      value={item?.name}
                      onChange={(e) => handleListDetailsOnChange(e, index)}
                      placeholder="Name"
                      inputClassName="form-control"
                      labelClassName="form-label"
                      labelStyle={{ display: "none" }}
                      asterisk={true}
                      customError={formErrors?.list_details?.[index]?.name}
                    />
                  </td>
                  <td style={{ width: "20%", textAlign: "center" }}>
                    <div onClick={() => handleRemoveListDetails(index)}>
                      <Link className="text-danger">
                        <i className="mdi mdi-trash-can font-size-20"></i>
                      </Link>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Row>

      <Row className="mt-4">
        <Col lg="12">
          <CheckboxInput
            label="Is Active"
            name="is_active"
            value={formData?.inputData?.is_active}
            checked={formData?.inputData?.is_active}
            handleTextChange={onInputChange}
            parentClassName="form-check"
            checkBoxClassName="form-check-input"
            labelClassName="form-check-label"
            disabled={false}
            required={false}
            customError={formErrors.is_active}
          />
        </Col>
      </Row>
    </CustomForm>
  );
};

export default CommissioningCreate;
